import React, { memo, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { Route, Switch } from 'react-router-dom';

import routes from '@/routes';

import { GlobalStyle } from './style';

function App() {
  const helmetMeta = [
    {
      name: 'robots',
      content: 'noindex, nofollow',
    },
  ];

  const renderRoute = useCallback(
    ({ component: RouteComponent, id, props, ...routeProps }) => (
      <Route
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...routeProps}
        key={id}
      >
        <RouteComponent {...props} />
      </Route>
    ),
    []
  );

  return (
    <>
      <GlobalStyle />
      <Helmet meta={helmetMeta} />
      <Switch>{routes.map(renderRoute)}</Switch>
    </>
  );
}

export default memo(App);
